const DAY = 86400000
const localDate = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit' })

// Calendar days, not elapsed 24-hour periods: timestamps follow the account's
// timezone, while a date-only start must keep its original calendar date.
export function ganttDay(value) {
  if (!value) return null
  let date = String(value)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const parsed = new Date(value)
    if (!Number.isFinite(parsed.getTime())) return null
    const parts = Object.fromEntries(localDate.formatToParts(parsed).map(p => [p.type, p.value]))
    date = `${parts.year}-${parts.month}-${parts.day}`
  }
  const ms = Date.parse(`${date}T00:00:00Z`)
  return Number.isFinite(ms) && new Date(ms).toISOString().slice(0, 10) === date ? ms / DAY : null
}

export function ganttDate(day, options = { day: '2-digit', month: '2-digit', year: 'numeric' }) {
  return day == null ? 'Não definido' : new Date(day * DAY).toLocaleDateString('pt-BR', { ...options, timeZone: 'UTC' })
}

export function taskSchedule(task) {
  const explicitStart = ganttDay(task.data_inicio)
  const start = explicitStart ?? ganttDay(task.created_at)
  const end = ganttDay(task.prazo)
  const issue = end == null ? 'Sem prazo' : start == null ? 'Sem início' : end < start ? 'Prazo anterior ao início' : null
  return { start, end, issue, fromCreation: explicitStart == null && start != null }
}

export function ganttSegment(schedule, from, days) {
  if (schedule.issue || schedule.end < from || schedule.start >= from + days) return null
  const start = Math.max(schedule.start, from)
  const end = Math.min(schedule.end, from + days - 1)
  return { left: (start - from) / days * 100, width: (end - start + 1) / days * 100,
    clippedStart: schedule.start < from, clippedEnd: schedule.end >= from + days }
}

export function firstScheduledDay(tasks, fallback) {
  const starts = tasks.map(taskSchedule).filter(s => !s.issue).map(s => s.start)
  return starts.length ? Math.min(...starts) : fallback
}

export function sortGanttTasks(tasks) {
  return [...tasks].sort((a, b) => {
    const left = taskSchedule(a), right = taskSchedule(b)
    return Number(!!left.issue) - Number(!!right.issue)
      || (left.start ?? Infinity) - (right.start ?? Infinity)
      || a.titulo.localeCompare(b.titulo, 'pt-BR')
  })
}
